import { render, staticRenderFns } from "./CommunityFriendsList.vue?vue&type=template&id=6e7ea99f"
import script from "./CommunityFriendsList.vue?vue&type=script&lang=js"
export * from "./CommunityFriendsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports